// @core/api/endpoints/form/list_forms.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFormsResponse,
} from '../../../types/form';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/form';

/**
 * List forms
 * Returns all forms for the current tenant. Supports filtering by status and search.
 */
export async function ListForms(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFormsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/forms`;
  const requestOptions = options;
  return client.get<ListFormsResponse>(requestPath, { ...requestOptions, params });
}
